import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    token: '',
    user: {},
    expire: 0,
    editorMode: false
  },
  mutations: {
    changeToken (state, newToken) {
      state.token = newToken;
    },
    changeUser (state, newUser) {
      state.user = newUser;
    },
    changeExpire (state, newExpire) {
      state.expire = newExpire;
    },
    setDefault (state, value) {
      state.token = '';
      state.user = {};
      state.expire = 0;
      state.editorMode = false;
    },
    changeEditorMode (state, value) {
      state.editorMode = value;
    }
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
    expire: state => state.expire,
    loginUser: () => {
      return JSON.parse(localStorage.getItem('user')
        ? localStorage.getItem('user')
        : sessionStorage.getItem('user'));
    },
    editorMode: state => state.editorMode
  },
  actions: {
    changeToken ({ commit }, value) {
      commit('changeToken', value);
    },
    changeUser ({ commit }, value) {
      commit('changeUser', value);
    },
    changeExpire ({ commit }, value) {
      commit('changeExpire', value);
    },
    clearAll ({ commit }, value) {
      commit('setDefault', value);
    },
    changeEditorMode ({ commit }, value) {
      commit('changeEditorMode', value);
    }
  }
});

export default store;
